import {
  EditorElementLayout,
  ContentResizeDirection,
  ResizeDirection,
} from '../types';

export const DefaultLayout: EditorElementLayout = {
  resizeDirection: ResizeDirection.horizontalAndVertical,
  contentResizeDirection: ContentResizeDirection.horizontalAndVertical,
  disableStretching: false,
  disablePositioning: false,
  disableRotation: false,
};
